// import axios from "axios";
import { FavouriteValue } from '../hooks/filters/interfaces/favourite-value.interface';

//const API_URL = process.env.REACT_APP_API_URL;
export const FAV_LS_KEY = 'iris-fav-list';
export const H_LS_KEY = 'iris-h-list';
export const FAV_ID_PREFIX = 'iris-';
export const H_ID_PREFIX = 'iris-h-';

const favouriteCache: Record<string, FavouriteValue> = {};

const addFavouteIdList = (id: string, listId: string) => {
  const ls = localStorage.getItem(listId);
  const list = ls ? JSON.parse(ls) : [];
  if (list.indexOf(id) === -1) {
    list.push(id);
    localStorage.setItem(listId, JSON.stringify(list));
  }
};

const removeFavouteIdList = (id: string, listId: string) => {
  const ls = localStorage.getItem(listId);
  if (ls) {
    const list = JSON.parse(ls);
    if (list && list.length > 0) {
      list.splice(list.indexOf(id), 1);
      localStorage.setItem(listId, JSON.stringify(list));
    }
  }
};

export const removeFavouteOlderList = (listId: string) => {
  const ls = localStorage.getItem(listId);
  if (ls) {
    const list: FavouriteValue[] | undefined = JSON.parse(ls);
    if (list && list.length > 0) {
      const newList: FavouriteValue[] = [];
      list
        .sort((a, b) => (new Date(a.date) > new Date(b.date) ? 1 : -1))
        .forEach((i, index) => {
          if (index > 3) {
            removeFavouriteValueFromCache(i.id);
            localStorage.removeItem(i.id);
          } else {
            newList.push(i);
          }
        });
      localStorage.setItem(listId, JSON.stringify(newList));
    }
  }
};
export const setFavouriteValueToCache = (selectedValue: FavouriteValue) => {
  favouriteCache[selectedValue.id] = selectedValue;
  return selectedValue;
};
export const removeFavouriteValueFromCache = (id: string) => {
  delete favouriteCache[id];
};
export const getFavouriteValue = (id: string) => {
  return favouriteCache[id];
};
export const getFavouriteValueService = async (
  id: string,
): Promise<FavouriteValue | null> => {
  const val = getFavouriteValue(id);
  if (val === undefined) {
    const jsonData = localStorage.getItem(id);
    if (jsonData) {
      const data: FavouriteValue = JSON.parse(jsonData);
      const ret = { ...data, date: new Date(data.date) };
      setFavouriteValueToCache(ret);

      return ret;
    } else {
      return null;
    }
  } else {
    return val;
  }
};

export const setFavouriteValueService = async (
  selectedValue: FavouriteValue,
  listId: string,
): Promise<FavouriteValue> => {
  setFavouriteValueToCache(selectedValue);
  const jsonData = JSON.stringify(selectedValue);
  localStorage.setItem(selectedValue.id, jsonData);
  addFavouteIdList(selectedValue.id, listId);
  return selectedValue;
};

export const removeFavouriteValueService = async (
  id: string,
  listId: string,
): Promise<void> => {
  removeFavouriteValueFromCache(id);
  localStorage.removeItem(id);
  removeFavouteIdList(id, listId);
};

export const getFavouriteListService = async (
  listId: string,
): Promise<FavouriteValue[]> => {
  const ls = localStorage.getItem(listId);
  const ret: FavouriteValue[] = [];
  if (ls) {
    const list = JSON.parse(ls);
    for (let index = 0; index < list.length; index++) {
      const id = list[index];
      const item = await getFavouriteValueService(id);
      if (item) {
        ret.push(item);
      }
    }
    return ret;
  } else {
    return ret;
  }
};
